import { useEffect, useState } from 'react';
import axios from 'axios';

const LIVE_URL = (process.env.REACT_APP_LIVES_SERVER_URL || 'https://live-gateway.azurewebsites.net/').replace(/\/$/, '');

// Polls the live gateway for sessions that have ended but are still being archived, and returns
// the entry for this live stream while it is in that window (null otherwise).
export function useAwaitingArchive(liveId, state, enabled = true, pollIntervalMs = 30000) {
  const [awaitingItem, setAwaitingItem] = useState(null);

  useEffect(() => {
    if (!enabled || !liveId || !state) {
      setAwaitingItem(null);
      return;
    }

    let active = true;
    const plainAxios = axios.create({});

    const poll = async () => {
      try {
        const res = await plainAxios.get(`${LIVE_URL}/app/${state}/live/awaiting-archive`);
        const items = res.data?.data || [];
        if (!active) return;
        setAwaitingItem(items.find((item) => String(item.Id) === String(liveId)) || null);
      } catch {
        if (active) setAwaitingItem(null);
      }
    };

    poll();
    const interval = setInterval(poll, pollIntervalMs);

    return () => {
      active = false;
      clearInterval(interval);
    };
  }, [enabled, liveId, state, pollIntervalMs]);

  return { awaitingItem };
}
